var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    slope: 0.05,
    type: "linear"
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "day",
    filter: "url(#blur)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,32)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "am-weather-sun am-weather-sun-shiny am-weather-easing-ease-in-out"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3,
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3,
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3,
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3,
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3,
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3,
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3,
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(315)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3,
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "orange",
    stroke: "orange",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDay);
export default __webpack_public_path__ + "static/media/day.cec9d8ac6004e68a30a6c6d0595e6ac3.svg";
export { ForwardRef as ReactComponent };